module.exports = __webpack_public_path__ + "static/media/mastercard.7ea6d120.png";